import { Alert } from '@zooplus/ui-components';

import styles from './Banner.module.scss';

interface Props {
  innerHtml: string;
  variant?: 'info' | 'success' | 'warning';
}
const HtmlEmbeddedAlert: React.FC<Props> = ({ innerHtml, variant = 'info' }) => {
  return (
    <Alert variant={variant} className={styles.alertWrapper}>
      {/* TODO: this is susceptible to xss attacks we should improve this , problem is we get the anchor link from the translation , so that it easy to change without deploying code , we should align and change this if we manage the anchor link differently */}
      <p
        dangerouslySetInnerHTML={{
          __html: innerHtml,
        }}
      />
    </Alert>
  );
};

export default HtmlEmbeddedAlert;
